<div [class]="theme">
  <p-progressBar [mode]="mode" [styleClass]="styleClass"></p-progressBar>
</div>
